import type { IHeadingFields } from 'types/generated/contentful';
import { getDynamicValueDependingOnUser } from './getDynamicValueDependingOnUser';

export function getDynamicContentfulHeading({
  hasUser,
  value,
}: {
  hasUser: boolean;
  value: IHeadingFields | null;
}): string | undefined {
  const heading = getDynamicValueDependingOnUser({ hasUser, value });
  if (heading !== null) {
    return heading;
  }
  return undefined;
}
